import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '../../stores/authStore';

interface FormsRouteProps {
  children: React.ReactNode;
}

const FormsRoute: React.FC<FormsRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has access to Service Forms page
  // Account Managers should not have access to Service Forms
  // Exception: Auditors can access all pages (view-only)
  const hasFormsAccess = user && (user.role !== UserRole.ACCOUNT_MANAGER || user.hasAuditAccess);

  if (!hasFormsAccess) {
    // Redirect to dashboard if user doesn't have forms access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default FormsRoute;
